import { t } from '../../services/i18nService';

import * as idVerificationActions from '../../actions/IdVerificationActions';
import * as idVerificationConstants from '../../services/idverification/IdVerificationConstants';

const similarityCheckFailedSelector = {
    selectMessage(verificationStatus) {
        const { REJECTED } = idVerificationActions.similarityMessageTypes;

        return (
            (verificationStatus === REJECTED)
                ? t('idVerification.similarity.REJECTED')
                : t(idVerificationConstants.internationalizationRequestWentWrongKey)
        );
    },

    selectTryAgainLabel() {
        return t('idVerification.overview.retry');
    },

    mapStateToProps({ idverification }) {
        return {
            message: this.selectMessage(idverification.verificationStatus),
            tryAgainLabel: this.selectTryAgainLabel(),
        };
    },
};

export default similarityCheckFailedSelector;
